import { useStore } from "zustand";
import { useIsSharedWorkspace } from "@/hooks/use-shared-workspace";
import { coreStore } from "@/lib/stores/core-store";
import { cn } from "@/lib/utils";

type ProfileOrganizationProps = {
	uid: string;
	className?: string;
};

export function ProfileOrganization({
	uid,
	className,
}: ProfileOrganizationProps) {
	const shared = useIsSharedWorkspace();
	const organizationName = useStore(
		coreStore,
		(state) => state.users.get(uid)?.profile.organization?.name
	);

	if (!(shared && organizationName)) return null;

	return (
		<span
			className={cn("truncate text-muted-foreground text-xs", className)}
			title={organizationName}
		>
			{organizationName}
		</span>
	);
}
